import { makeStyles } from '@material-ui/core'
import React, { useState } from 'react'

const useStyles = makeStyles((theme) => ({
  form: {
    '& .MuiFormControl-root': {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(2),
    },
  },
}))

const useForm = (initialValues, validateOnChange = false, validate) => {
  const [values, setValues] = useState(initialValues)
  const [errors, setErrors] = useState({})

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: value,
    })
    if (validateOnChange) {
      validate({ [name]: value })
    }
  }

  const resetForm = () => {
    setValues(initialValues)
    setErrors({})
  }

  return {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm,
  }
}

const Form = ({ children, ...other }) => {
  const classes = useStyles()
  return (
    <form className={classes.form} autoComplete='off' {...other}>
      {children}
    </form>
  )
}

export { useForm, Form }
